export default "__VITE_ASSET__594640c2__"